import * as Actions from 'store/actions/app/product_requests.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_user_product_requests: false,
  user_product_requests: [],

  loading_product_requests_sorted_by_user: false,
  product_requests_sorted_by_user: [],

  saving_product_request: false,
  saved_product_request: false,

  updating_product_request_quantity_ids: [],
  updated_product_request_quantity_ids: [],

  removing_product_request_ids: [],
  removed_product_request_ids: [],
}

export default function productRequestsReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_USER_PRODUCT_REQUESTS: {
      return {
        ...state,
        loading_user_product_requests: action.payload.loading,
        user_product_requests: action.payload.data ?? state.user_product_requests,
      }
    }
    case Actions.GET_PRODUCT_REQUESTS_SORTED_BY_USER: {
      return {
        ...state,
        loading_product_requests_sorted_by_user: action.payload.loading,
        product_requests_sorted_by_user: action.payload.data ?? state.product_requests_sorted_by_user,
      }
    }
    case Actions.SAVE_PRODUCT_REQUEST: {
      return {
        ...state,
        saving_product_request: action.payload.saving ?? false,
        saved_product_request: action.payload.saved ?? false,
        user_product_requests: action.payload.data
          ? addOrUpdateObjectInArray(state.user_product_requests, action.payload.data, 'requerimiento_producto_id', true)
          : state.user_product_requests
      }
    }
    case Actions.UPDATE_PRODUCT_REQUEST_QUANTITY: {
      return {
        ...state,
        updating_product_request_quantity_ids: toggleIdInArray(state.updating_product_request_quantity_ids, action.payload.updating_id),
        updated_product_request_quantity_ids: toggleIdInArray(state.updated_product_request_quantity_ids, action.payload.updated_id),
        user_product_requests: action.payload.data
          ? addOrUpdateObjectInArray(state.user_product_requests, action.payload.data, 'requerimiento_producto_id')
          : state.user_product_requests
      }
    }
    case Actions.REMOVE_PRODUCT_REQUEST: {
      return {
        ...state,
        removing_product_request_ids: toggleIdInArray(state.removing_product_request_ids, action.payload.removing_id),
        removed_product_request_ids: toggleIdInArray(state.removed_product_request_ids, action.payload.removed_id),
        user_product_requests: state.user_product_requests.filter(item => item.requerimiento_producto_id !== action.payload.removed_id)
      }
    }
    default: {
      return state
    }
  }
}
